import { useEffect, useState } from "react";

export const useDeferredReady = (enabled = true) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setIsReady(false);
      return;
    }

    const id = requestAnimationFrame(() => {
      setIsReady(true);
    });

    return () => cancelAnimationFrame(id);
  }, [enabled]);

  return isReady;
};
